import script from "./OrderInfoTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderInfoTable.vue?vue&type=script&setup=true&lang=js"

import "./OrderInfoTable.vue?vue&type=style&index=0&id=38605ce7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38605ce7"]])

export default __exports__